/**
 * Spec 27 - types + Zod-schemas voor de persistente tegel-layout van het
 * Targeting-dashboard. Eén layout per gebruiker, server-side bewaard.
 */
import { z } from 'zod'

/** Eén react-grid-layout tegel (positie + grenzen). */
export const targetingTileSchema = z.object({
  i: z.string().min(1),
  x: z.number().int().min(0),
  y: z.number().int().min(0),
  w: z.number().int().min(1).max(12),
  h: z.number().int().min(1).max(20),
  minW: z.number().int().min(1).optional(),
  minH: z.number().int().min(1).optional(),
  maxW: z.number().int().min(1).optional(),
  maxH: z.number().int().min(1).optional(),
})
export type TargetingTile = z.infer<typeof targetingTileSchema>

export const targetingDashboardLayoutSchema = z.object({
  layout: z.array(targetingTileSchema).min(1).max(20),
})
export type TargetingDashboardLayoutInput = z.infer<typeof targetingDashboardLayoutSchema>

export interface TargetingDashboardLayoutDTO {
  layout: TargetingTile[]
}
